import { ChatConfig, MembersLibConfig, PermissionConfig } from '@lib/members/feature';

// Chat configuration for health manager portal
export const healthManagerChatConfig: ChatConfig = {
  enabled: true,
  threadType: 'HealthManagerChannel',
  allowFileUpload: true,
  maxMessageLength: 5000,
  enableNotifications: true,
};

export const healthManagerPermissionConfig: PermissionConfig = {
  permissions: ['hm.read', 'hm.write', 'doctor.read', 'doctor.write'],
  roles: ['health_manager', 'admin'],
};

export const healthManagerMembersConfig: MembersLibConfig = {
  chatConfig: healthManagerChatConfig,
  permissionConfig: healthManagerPermissionConfig,
  features: {
    showDoctorEdit: true,
    showPartnerIdEdit: true,
    showChatButton: true,
    showExternalRefs: true,
    showMedicalHistory: true,
    showPrescriptions: true,
    showAppointments: true,
    showComments: true,
    showHealthCheckScheduler: true,
    showPackageCoverage: true,
  },
};